import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAppConfig } from './models/config';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private configuration: any;

  constructor(private readonly httpClient: HttpClient) { }

  async setConfig(): Promise<IAppConfig> {
    this.configuration = await firstValueFrom(
      this.httpClient.get<IAppConfig>('../assets/jsons/config.json')
    );
    return this.configuration;
  }

  readConfig(): IAppConfig {
    return this.configuration;
  }

  readUrl() {
    return this.configuration.apiUrl;
  }
}